(function () {
  'use strict';
  var context = window.LDAdContext || {};
  var code = context.code;
  var filmCollections = {"W1010B001":"wzory-z-filmu-vd01","W1010B002":"wzory-z-filmu-vd02","W1010B003":"wzory-z-filmu-vd03","W1010B004":"wzory-z-filmu-vd04","W1010B005":"wzory-z-filmu-vd05","W1010B006":"wzory-z-filmu-vd06","W1010B007":"wzory-z-filmu-vd07","W1010B008":"wzory-z-filmu-vd08","W1010B009":"wzory-z-filmu-vd09","W1010B00A":"wzory-z-filmu-vd10","W1010B00B":"wzory-z-filmu-vd11","W1010B00C":"wzory-z-filmu-vd12","W1010B00D":"wzory-z-filmu-vd13","W1010B00E":"wzory-z-filmu-vd14"};
  var collectionHandle = filmCollections[code] || (code ? 'ad-' + code.toLowerCase() : '');
  if (!code || context.expired) return;
  var jobs = new WeakSet();
  var requests = new Map();
  function release() {
    clearTimeout(context.timer);
    document.documentElement.classList.remove('ld-ad-pending');
    document.dispatchEvent(new CustomEvent('ld:ad:release'));
  }
  function cardsOf(grid) {
    return grid ? Array.from(grid.children).filter(function (node) { return node.hasAttribute('data-ld-product-id'); }) : [];
  }
  function availableCard(card) {
    return card.dataset.ldProductAvailable === 'true';
  }
  function webp(raw) {
    if (!raw) return raw;
    var url = new URL(raw, location.href);
    if (url.origin === location.origin || /(^|\.)shopify\.com$/.test(url.hostname)) url.searchParams.set('format', 'webp');
    return url.href;
  }
  var imageRequests = new Map();
  var canvasWebpSupport = null, encoderRequest = null;
  async function encodeCanvas(canvas) {
    if (!canvasWebpSupport) canvasWebpSupport = new Promise(function (resolve) {
      var probe = document.createElement('canvas'); probe.width = 1; probe.height = 1;
      probe.toBlob(function (blob) { resolve(!!blob && blob.type === 'image/webp'); }, 'image/webp');
    });
    if (await canvasWebpSupport) return new Promise(function (resolve) { canvas.toBlob(resolve, 'image/webp', 0.92); });
    if (!encoderRequest) encoderRequest = import(context.webpEncoder);
    var encoder = await encoderRequest;
    var bytes = await encoder.encodeWebp(canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height));
    return new Blob([bytes], { type: 'image/webp' });
  }
  function webpImage(raw) {
    var url = webp(raw);
    if (imageRequests.has(url)) return imageRequests.get(url);
    var promise = (async function () {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 4000);
      try {
        var response = await fetch(url, { headers: { Accept: 'image/webp' }, signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Image unavailable');
        var blob = await response.blob();
        if (blob.type !== 'image/webp') {
          var bitmap = await createImageBitmap(blob);
          var canvas = document.createElement('canvas');
          canvas.width = bitmap.width; canvas.height = bitmap.height;
          canvas.getContext('2d').drawImage(bitmap, 0, 0); bitmap.close();
          blob = await encodeCanvas(canvas);
          canvas.width = 0; canvas.height = 0;
          if (!blob || blob.type !== 'image/webp') throw new Error('WebP unavailable');
        }
        return URL.createObjectURL(blob);
      } finally { clearTimeout(timer); }
    })();
    imageRequests.set(url, promise);
    return promise;
  }
  async function prepareImages(scope) {
    await Promise.all(Array.from(scope.querySelectorAll('img')).map(async function (img) {
      await Promise.all(['src', 'data-image-1', 'data-image-2'].map(async function (attribute) {
        if (img.hasAttribute(attribute)) img.setAttribute(attribute, await webpImage(img.getAttribute(attribute)));
      }));
      img.removeAttribute('srcset');
      img.loading = 'eager';
    }));
  }
  function uniqueIDs(scope, suffix) {
    var replacements = new Map();
    scope.querySelectorAll('[id]').forEach(function (node, index) {
      var old = node.id, next = old + '-ld-ad-' + suffix + '-' + index;
      replacements.set(old, next); node.id = next;
    });
    scope.querySelectorAll('[for],[form],[aria-controls],[aria-labelledby],[aria-describedby],[href^="#"]').forEach(function (node) {
      ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attribute) {
        if (node.hasAttribute(attribute)) node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(function (id) { return replacements.get(id) || id; }).join(' '));
      });
      var href = node.getAttribute('href');
      if (href && replacements.has(href.slice(1))) node.setAttribute('href', '#' + replacements.get(href.slice(1)));
    });
  }
  function requestKey(root) {
    var theme = window.Shopify && Shopify.theme ? Shopify.theme.id : '';
    var meta = root.querySelector('[data-ld-feed-meta]');
    var currency = meta ? JSON.parse(meta.textContent).currency : '';
    return [theme, root.dataset.ldSection, document.documentElement.lang, currency, code].join(':');
  }
  async function load(root) {
    var key = requestKey(root);
    if (requests.has(key)) return requests.get(key);
    var job = (async function () {
      var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      var url = new URL(base + 'collections/' + collectionHandle, location.origin);
      url.searchParams.set('section_id', root.dataset.ldSection);
      url.searchParams.set('filter.v.availability', '1');
      if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id', Shopify.theme.id);
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 5000);
      try {
        var html = [], page = 1;
        while (url) {
          var response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return null;
          var source = new DOMParser().parseFromString(await response.text(), 'text/html');
          var returned = source.querySelector('[data-ld-collection]');
          var grid = returned && returned.querySelector('[data-ld-product-grid]');
          var metaNode = returned && returned.querySelector('[data-ld-feed-meta]');
          if (!grid || !metaNode) return null;
          var meta = JSON.parse(metaNode.textContent), cards = cardsOf(grid);
          if (meta.path !== base + 'collections/' + collectionHandle || meta.page !== page || cards.length !== meta.rendered) return null;
          cards.filter(availableCard).forEach(function (card) { html.push(card.outerHTML); });
          if (meta.next) { page++; url.searchParams.set(meta.pageParam, page); } else url = null;
        }
        if (!html.length) return null;
        return html.join('');
      } finally { clearTimeout(timer); }
    })();
    requests.set(key, job);
    try { return await job; }
    finally { requests.delete(key); }
  }
  async function mount(root) {
    var slot = root.querySelector('[data-ld-ad-slot]');
    var normalGrid = root.querySelector('[data-ld-product-grid]');
    if (!slot || jobs.has(root)) return;
    jobs.add(root); root.dataset.ldAdState = 'loading';
    try {
      var html = await load(root);
      if (!html || !root.isConnected || context.expired) { root.dataset.ldAdState = 'empty'; return; }
      var staging = document.createElement('template'); staging.innerHTML = html;
      var cards = Array.from(staging.content.children);
      var grid = document.createElement('ul');
      grid.className = normalGrid ? normalGrid.className : 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
      grid.setAttribute('data-ld-ad-grid', ''); grid.setAttribute('role', 'list');
      var seen = new Set();
      cards.forEach(function (card, index) {
        var id = card.dataset.ldProductId;
        if (!id || seen.has(id) || !availableCard(card)) return;
        seen.add(id); uniqueIDs(card, root.dataset.ldSection + '-' + index);
        card.querySelectorAll('script:not([type="application/json"])').forEach(function (script) { script.remove(); });
        grid.appendChild(card);
      });
      if (!seen.size) { root.dataset.ldAdState = 'empty'; return; }
      await prepareImages(grid);
      if (context.expired || !root.isConnected) { root.dataset.ldAdState = 'empty'; return; }
      root.dataset.ldAdIds = Array.from(seen).join(',');
      slot.querySelector('[data-ld-ad-cards]').replaceChildren(grid);
      if (window.LDCollectionFeed && LDCollectionFeed.prepare) LDCollectionFeed.prepare(grid);
      if (normalGrid) cardsOf(normalGrid).forEach(function (card) {
        if (seen.has(card.dataset.ldProductId)) { card.setAttribute('data-ld-ad-duplicate', ''); card.hidden = true; }
      });
      slot.dataset.ldAdReady = 'true'; slot.hidden = false;
      root.dataset.ldAdState = 'ready';
      var heading = slot.querySelector('.ld-ad-products__title');
      root.querySelectorAll('[data-ld-pagination] a').forEach(function (link) {
        var url = new URL(link.href); url.hash = heading.id; link.href = url.href;
      });
      root.dispatchEvent(new CustomEvent('ld:ad:ready', { bubbles: true }));
    } catch (_) { root.dataset.ldAdState = 'empty'; }
    finally { release(); }
  }
  function boot(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-ld-collection]'));
    if (scope.matches && scope.matches('[data-ld-collection]')) roots.unshift(scope);
    roots.forEach(mount);
    if (!roots.length) release();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
})();

